import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { patchAppointment } from 'actions/appointments';
import { DefaultAvatar } from 'atoms/default-avatar';
import Dropdown from 'atoms/dropdown';
import toast from 'atoms/toast';
import useQuery from 'hooks/useQuery';
import { refreshAppointments } from 'organisms/Appointments/AppointmentActions/util';
import { requestFulfilled, requestOngoing } from 'store/reducers/ui';
import { capitalizeFirstLetter } from 'util';

export function CustomAvatarContent() {
  const { appointment } = useSelector((state) => state.checkout);
  return (
    <DefaultAvatar
      size="small"
      avatar={appointment?.locationUser?.links?.image?.desktop?.small}
      className="mr-10"
    />
  );
}

export default function ReassignDropdown() {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = useQuery();
  const { appointment } = useSelector((state) => state.checkout);
  const { groomers } = useSelector((state) => state.groomers);
  const groomersDropdownOptions = groomers.map(({ user }) => ({
    name: capitalizeFirstLetter(user.firstName),
    links: user.links,
    uuid: user.uuid,
  }));

  const onSelectGroomer = (groomer) => {
    if (!!appointment && !!groomer) {
      dispatch(requestOngoing());
      const {
        uuid,
        animal,
        location: providerLocation,
        service,
        dateStart,
        note,
      } = appointment;
      dispatch(
        patchAppointment(uuid, {
          uuid: {
            animal: animal?.uuid,
            location: providerLocation?.uuid,
            location_user: groomer?.uuid,
            service: service?.uuid,
          },
          date_start: dateStart,
          note,
        })
      ).then(({ success }) => {
        if (success) {
          refreshAppointments({ location, query, dispatch });
          toast({ text: 'Appointment reassigned!' });
        }
        dispatch(requestFulfilled());
      });
    }
  };

  return (
    <Dropdown
      id="reassign-dropdown"
      className="reassign-dropdown"
      variant="white"
      size="extra-small"
      shape="round"
      items={groomersDropdownOptions}
      value={capitalizeFirstLetter(appointment?.locationUser?.firstName)}
      CustomContent={CustomAvatarContent}
      onClick={onSelectGroomer}
    />
  );
}
